import { QueryStringIntegerSchema } from 'notable-common';
import { z } from 'zod';
/**
 * The rows a feed has delivered, filtered by the window they arrived in. `after` and `before` are
 * coerced to dates, the way the joi they shadow coerces them, because the query is compared
 * against a timestamp column.
 */
export const FeedItemFindAllQuerySchema = z
    .object({
    after: z.coerce.date().optional(),
    before: z.coerce.date().optional(),
    includeDeleted: z.stringbool({ truthy: ['true'], falsy: ['false'] }).default(false),
    limit: QueryStringIntegerSchema.optional(),
    practiceId: z.uuid().optional(),
})
    .strict();
//# sourceMappingURL=item.js.map